export enum CONTENT_EDITOR_TITLE  {
    ABOUT = "ABOUT",
    FAQ = "FAQ",
    TERMS = "TERMS",
    CONTACT = "CONTACT"
}
